import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, themeMode, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var Wrapper = styled(Box).withConfig({
  componentId: "sc-15vjvg5-0"
})(["flex:1;display:flex;flex-direction:column;align-items:center;border:1px dashed;border-radius:", ";outline:none;transition:border 0.24s ease-in-out;cursor:pointer;", ";", ";", ";"], radius("base"), themeMode({
  light: css(["border-color:", ";"], palette("neutral.400")),
  dark: css(["border-color:", ";"], palette("neutral.500"))
}), function (_ref) {
  var isLoading = _ref.isLoading,
      isInvalid = _ref.isInvalid;
  return !isInvalid && !isLoading && css(["&:hover{border-color:", ";}"], palette("primary.500"));
}, function (_ref2) {
  var isInvalid = _ref2.isInvalid;
  return isInvalid && css(["border-color:", ";"], palette("danger.500"));
});
export { Wrapper };